/* Befrù — correlati nel cart drawer con aggiunta rapida.
   Legge le raccomandazioni Shopify (intent=related) del primo articolo in carrello,
   esclude ciò che è già nel carrello e i non disponibili, mostra max N prodotti con
   selettore taglia + bottone "Aggiungi". L'aggiunta usa /cart/add.js con sections=cart-drawer,
   poi ri-renderizza il drawer con il metodo nativo di Dawn (cart-drawer.renderContents). */
(function () {
  if (customElements.get('befru-cart-upsell')) return;

  var cache = {};

  function money(cents) {
    var n = (cents / 100).toFixed(2).replace('.', ',');
    return '€' + n;
  }

  function pct(compare, price) {
    if (!compare || compare <= price) return 0;
    return Math.round(((compare - price) / compare) * 100);
  }

  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function imgUrl(src, width) {
    if (!src) return '';
    var url = src.indexOf('//') === 0 ? 'https:' + src : src;
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
  }

  function variantLabel(product, v) {
    var parts = [];
    var names = (product.options || []).map(function (o) {
      return (typeof o === 'string' ? o : o.name) || '';
    });
    ['option1', 'option2', 'option3'].forEach(function (k, i) {
      if (!v[k] || v[k] === 'Default Title') return;
      var prefix = '';
      if (/superiore/i.test(names[i])) prefix = 'Sopra ';
      else if (/inferiore/i.test(names[i])) prefix = 'Sotto ';
      parts.push(prefix + v[k]);
    });
    return parts.join(' / ') || v.title;
  }

  class BefruCartUpsell extends HTMLElement {
    connectedCallback() {
      var productId = this.dataset.productId;
      if (!productId) return;
      var self = this;
      this.exclude = (this.dataset.exclude || '').split(',').filter(Boolean);
      this.limit = parseInt(this.dataset.limit, 10) || 3;
      this.load(productId).then(function (products) {
        self.render(products);
      });
    }

    load(productId) {
      if (cache[productId]) return Promise.resolve(cache[productId]);
      var url = this.dataset.url + '.json?product_id=' + productId + '&intent=related&limit=8';
      return fetch(url)
        .then(function (r) { return r.json(); })
        .then(function (data) {
          cache[productId] = data.products || [];
          return cache[productId];
        })
        .catch(function () { return []; });
    }

    render(products) {
      var self = this;
      var list = this.querySelector('[data-list]');
      var picked = products
        .filter(function (p) { return p.available && self.exclude.indexOf(String(p.id)) === -1; })
        .slice(0, this.limit);
      if (!picked.length) { this.hidden = true; return; }

      list.innerHTML = picked.map(function (p) { return self.itemHTML(p); }).join('');
      this.hidden = false;

      this.initNav(list);

      list.querySelectorAll('.befru-upsell__item').forEach(function (el, i) {
        var product = picked[i];
        var select = el.querySelector('.befru-upsell__variant');
        var button = el.querySelector('.befru-upsell__add');
        if (select) {
          select.addEventListener('change', function () { self.updatePrice(el, product, select.value); });
        }
        button.addEventListener('click', function () {
          var variantId = select ? select.value : button.dataset.variantId;
          self.add(el, variantId);
        });
      });
    }

    initNav(list) {
      var nav = this.querySelector('[data-nav]');
      if (!nav) return;
      var step = function () {
        var card = list.querySelector('.befru-upsell__item');
        return card ? card.getBoundingClientRect().width + 10 : 120;
      };
      var update = function () {
        nav.hidden = list.scrollWidth <= list.clientWidth + 2;
      };
      nav.querySelector('[data-prev]').addEventListener('click', function () {
        list.scrollBy({ left: -step(), behavior: 'smooth' });
      });
      nav.querySelector('[data-next]').addEventListener('click', function () {
        list.scrollBy({ left: step(), behavior: 'smooth' });
      });
      requestAnimationFrame(update);
      window.addEventListener('resize', update);
    }

    itemHTML(p) {
      var variants = (p.variants || []).filter(function (v) { return v.available; });
      var first = variants[0];
      var url = p.url.split('?')[0];
      var selectHTML = '';
      if (variants.length > 1) {
        selectHTML =
          '<select class="befru-upsell__variant" aria-label="Taglia">' +
          variants.map(function (v) {
            return '<option value="' + v.id + '" data-price="' + v.price + '" data-compare="' + (v.compare_at_price || 0) + '">' +
              esc(variantLabel(p, v)) + '</option>';
          }).join('') +
          '</select>';
      }
      return (
        '<div class="befru-upsell__item">' +
          '<a class="befru-upsell__media" href="' + esc(url) + '">' +
            (p.featured_image ? '<img src="' + esc(imgUrl(p.featured_image, 160)) + '" alt="' + esc(p.title) + '" loading="lazy" width="64" height="85">' : '') +
          '</a>' +
          '<div class="befru-upsell__info">' +
            '<a class="befru-upsell__title" href="' + esc(url) + '">' + esc(p.title) + '</a>' +
            '<p class="befru-upsell__price" data-price>' + this.priceHTML(first.price, first.compare_at_price) + '</p>' +
            '<div class="befru-upsell__actions">' +
              selectHTML +
              '<button type="button" class="befru-upsell__add" data-variant-id="' + first.id + '">Aggiungi</button>' +
            '</div>' +
            '<p class="befru-upsell__error" data-error hidden></p>' +
          '</div>' +
        '</div>'
      );
    }

    priceHTML(price, compare) {
      var p = pct(compare, price);
      if (p > 0) {
        return '<s>' + money(compare) + '</s><strong>' + money(price) + '</strong><span class="befru-line-sale__pct">-' + p + '%</span>';
      }
      return '<strong>' + money(price) + '</strong>';
    }

    updatePrice(el, product, variantId) {
      var v = (product.variants || []).filter(function (x) { return String(x.id) === String(variantId); })[0];
      if (!v) return;
      el.querySelector('[data-price]').innerHTML = this.priceHTML(v.price, v.compare_at_price);
    }

    add(el, variantId) {
      var button = el.querySelector('.befru-upsell__add');
      var error = el.querySelector('[data-error]');
      var drawer = document.querySelector('cart-drawer');
      var sections = ['cart-drawer', 'cart-icon-bubble'];
      button.disabled = true;
      error.hidden = true;
      fetch(this.dataset.addUrl + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
        body: JSON.stringify({
          items: [{ id: parseInt(variantId, 10), quantity: 1 }],
          sections: sections.join(','),
          sections_url: window.location.pathname,
        }),
      })
        .then(function (r) { return r.json(); })
        .then(function (json) {
          if (json.status) {
            error.textContent = json.description || json.message || 'Prodotto non disponibile';
            error.hidden = false;
            button.disabled = false;
            return;
          }
          if (typeof publish === 'function' && window.PUB_SUB_EVENTS) {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'befru-cart-upsell', productVariantId: variantId, cartData: json });
          }
          if (drawer && typeof drawer.renderContents === 'function') {
            drawer.classList.remove('is-empty');
            drawer.renderContents(json);
          } else {
            window.location.reload();
          }
        })
        .catch(function () {
          error.textContent = 'Errore, riprova';
          error.hidden = false;
          button.disabled = false;
        });
    }
  }

  customElements.define('befru-cart-upsell', BefruCartUpsell);
})();
